const DEFAULT_ERROR_MESSAGE = 'İşlem sırasında bir hata oluştu. Lütfen tekrar deneyin.'

/**
 * Başarısız istek hatasını ekranların gösterebileceği sonuca çevirir.
 * Backend mesajı varsa onu, yoksa verilen (ya da varsayılan) mesajı kullanır.
 */
const toErrorResult = (error, fallbackMessage = DEFAULT_ERROR_MESSAGE) => {
  console.error(error)
  return {
    status: false,
    message: error.response?.data?.message || fallbackMessage,
  }
}

export default toErrorResult
